import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from '@mui/material';


const OrderDetailsDialog = ({
  order,
  onClose,
  isMobile,
  detailFields,
  formatTime,
  showRejectionReason = true,
  titleConfig = {
    leftContent: (order) => (
      <>
        {order.trading_symbol}
        <Typography
          component="span"
          variant="caption"
          color="text.secondary"
          sx={{ ml: 0.5 }}
        >
          ({order.order_side}, {order.exchange})
        </Typography>
      </>
    ),

    rightContent: (order) => `${order.trade_quantity || order.filled_quantity}/${order.quantity || order.trade_quantity}`
  }
}) => {
  if (!order) return null;
  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '400px'
        }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          borderBottom: '3px solid',
          borderColor: order.order_side === 'BUY' ? 'success.main' : 'error.main'
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <Typography>
            {titleConfig.leftContent(order)}
          </Typography>
          <Typography>
            {titleConfig.rightContent(order)}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 2
        }}>
          {detailFields.map((field, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
            >
              <Typography>{field.value}</Typography>
              <Typography variant="caption" color="text.secondary">
                {field.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>

      {showRejectionReason && order.rejection_reason && order.rejection_reason !== 'NONE' && (
        <Box sx={{
          mt: 3,
          mx: 2,
          mb: 3
        }}>
          <Typography
            variant="body2"
            sx={{
              p: 1.5,
              backgroundColor: 'rgb(229, 246, 253)',
              color: 'rgb(1, 67, 97)',
              borderRadius: 1,
              fontWeight: 500
            }}
          >
            Rejection Reason: {order.rejection_reason}
          </Typography>
        </Box>
      )}

      <Box sx={{
        p: 2,
        borderTop: 1,
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 1
      }}>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
      </Box>
    </Dialog>
  );
};

export default OrderDetailsDialog; 